import axiosInstance from "api/axiosInstance";

import type { LessonRequestListItem, LessonRequestDetail, LessonRequestListParams, PaginatedResponse } from "api/types/lesson-request.types";

// 콜잡기(강습 요청) 어드민 조회 API — 읽기 전용
// Base URL: /server/buccl_lessons/api/v1/admin/lesson-requests/
const BASE = "/server/buccl_lessons/api/v1/admin/lesson-requests/";

export const lessonRequestService = {
  // 3-1. 목록 조회 (DRF 표준 페이지네이션)
  list: (params?: LessonRequestListParams) => axiosInstance.get<PaginatedResponse<LessonRequestListItem>>(BASE, { params }),

  // 3-2. 상세 조회
  get: (id: number) => axiosInstance.get<LessonRequestDetail>(`${BASE}${id}/`),
};
